import { useMapStore } from '@/features/map-core';
import type { ChoroplethView } from './types';
import { viewForZoom } from './view-logic';

export { viewForZoom };

export function useChoroplethView(): ChoroplethView {
  const zoom = useMapStore((s) => s.zoom);
  return viewForZoom(zoom);
}
